import {
  Link,
  createTableColumn,
  TableColumnDefinition,
} from "@fluentui/react-components";
import i18n from "i18next";
import { IKonfigurationSt } from "../../../Models/IKonfigurationSt";

interface IColumnsConfiStSalesProps {
  openDialogWithConfig(item: IKonfigurationSt): void;
}

export function ColumnsConfiStSales(props: IColumnsConfiStSalesProps) {
  const columns: TableColumnDefinition<IKonfigurationSt>[] = [
    createTableColumn<IKonfigurationSt>({
      columnId: "configId",
      compare: (a, b) => {
        if (a.id && b.id) {
          return a.id.localeCompare(b.id);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "ID";
      },
      renderCell: (item) => {
        return (
          <Link
            onClick={() => {
              props.openDialogWithConfig(item);
            }}
          >
            {item.id}
          </Link>
        );
      },
    }),
    createTableColumn<IKonfigurationSt>({
      columnId: "statusId",
      compare: (a, b) => {
        if (a.status && b.status) {
          return a.status - b.status;
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("status");
      },
      renderCell: (item) => {
        return i18n.t<string>("configStatus" + item.status);
      },
    }),
    createTableColumn<IKonfigurationSt>({
      columnId: "systemId",
      compare: (a, b) => {
        if (
          a.positionen[0].artikel?.benennungDE &&
          b.positionen[0].artikel?.benennungDE
        ) {
          if (i18n.language.includes("de")) {
            return a.positionen[0].artikel?.benennungDE.localeCompare(
              b.positionen[0].artikel?.benennungDE,
            );
          } else if (
            a.positionen[0].artikel?.benennungEN != undefined &&
            b.positionen[0].artikel?.benennungEN != undefined
          ) {
            return a.positionen[0].artikel?.benennungEN.localeCompare(
              b.positionen[0].artikel?.benennungEN,
            );
          } else return 0;
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("schraubsystem");
      },
      renderCell: (item) => {
        if (item.positionen?.length > 0) {
          return (
            <div className="lueb-centerVertical">
              {i18n.language.includes("de")
                ? item.positionen[0].artikel?.benennungDE
                : item.positionen[0].artikel?.benennungEN}
            </div>
          );
        }
      },
    }),
    createTableColumn<IKonfigurationSt>({
      columnId: "GesendetVonId",
      compare: (a, b) => {
        if (a.gesendetVon && b.gesendetVon) {
          return a.gesendetVon.fullName.localeCompare(b.gesendetVon.fullName);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("sentBy");
      },
      renderCell: (item) => {
        return item.gesendetVon?.fullName;
      },
    }),
    createTableColumn<IKonfigurationSt>({
      columnId: "gesendetAm",
      compare: (a, b) => {
        if (a.gesendetAm && b.gesendetAm) {
          return a.gesendetAm.localeCompare(b.gesendetAm);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("sentOn");
      },
      renderCell: (item) => {
        if (typeof item.gesendetAm == "string") {
          return new Date(item.gesendetAm).toLocaleString();
        }
      },
    }),
  ];

  return columns;
}
